import React from 'react'
import { graphql, Link, useStaticQuery } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import { useMergePrismicPreviewData } from 'gatsby-plugin-prismic-previews'

const Categories = () => {
  const staticData = useStaticQuery(graphql`
    {
      allPrismicCategory {
        edges {
          node {
            ...PrismicCategoryFragment
          }
        }
      }
    }
  `)
  const data = useMergePrismicPreviewData(staticData)
  return (
    <section className='page-block page-block--categories'>
      <div className='page-block-container'>
        <ul className='list'>
          {data.allPrismicCategory.edges.map((category, index) => {
            var categoryData = category.node.data
            return (
              <li className='category-preview' key={`category-${index}`}>
                <Link className='category-preview__link' aria-label={`Filter by the adventure category: ${categoryData.name.text}`} to={category.node.url}>
                  <h3 className='category-preview__title tag'>{categoryData.name.text}</h3>
                  <div className='category-preview__overlay'>
                    <p>{categoryData.description}</p>
                  </div>
                  {categoryData.image.gatsbyImageData && <GatsbyImage image={categoryData.image.gatsbyImageData} className='category-preview__image' alt={categoryData.image.alt || ''} />}
                </Link>
              </li>
            )
          })}
        </ul>
      </div>
    </section>
  )
}

export default Categories
